export default __webpack_public_path__ + "static/media/web_screen_chat_it.1ef1b961.png";